import React, { useEffect, useRef } from "react"
import { Animated, Easing } from "react-native"

/**
 * Un enfant qui entre en fondu montant (14 px), décalé de `index` × 110 ms :
 * les cartes d'un programme, les masteurs trouvés — ce qui vient d'être
 * composé arrive, il ne « s'affiche » pas. Une seule fois, au montage.
 * `from` règle la course : négatif, l'enfant descend à sa place.
 */
const FunnelFadeUp = ({ index = 0, delay = 0, from = 14, children, style }) => {
    const v = useRef(new Animated.Value(0)).current
    useEffect(() => {
        Animated.timing(v, {
            toValue: 1,
            duration: 460,
            delay: delay + index * 110,
            easing: Easing.out(Easing.cubic),
            useNativeDriver: true,
        }).start()
    }, [v, delay, index])
    return (
        <Animated.View
            style={[
                style,
                {
                    opacity: v,
                    transform: [
                        {
                            translateY: v.interpolate({
                                inputRange: [0, 1],
                                outputRange: [from, 0],
                            }),
                        },
                    ],
                },
            ]}
        >
            {children}
        </Animated.View>
    )
}

export default FunnelFadeUp
